import React, { memo } from 'react'
import { Box, useTheme } from '@mui/material'

import { formatTicks } from '../../../util/string.helpers'

import CustomDialog from '../../shared/CustomDialog/CustomDialog'
import Text from '../../shared/text/Text'
import FaIcon from '../../shared/FaIcon/FaIcon'
import { buildMemberTransactionTypeIconColor } from '../../../util/transaction/transaction.helpers'
import { CSS_FLEX_ALIGNED } from '../../../styles/common'

const TransactionConfirmation = ({
  t,
  memberTransactionProfile: { type, amount, isProcessing },
  tokenProfile: { name, symbol },
  ...restProps
}) => {
  const theme = useTheme()
  const { icon, color } = buildMemberTransactionTypeIconColor(type)

  return (
    <CustomDialog
      title={`${t(`member.transaction-filters.${type}`)} ${t(
        'member.confirmation'
      )}`}
      description={t('member.points-credit-debit-confirmation-msg', {
        name,
        action: t(`member.points-action-${type}`)
      })}
      open
      submitProps={{
        label: t('common.confirm'),
        disabled: isProcessing
      }}
      t={t}
      {...restProps}
      body={
        <Box sx={{ gap: 1, ...CSS_FLEX_ALIGNED }}>
          <FaIcon icon={icon} color={theme.palette[color].main} width={20} />
          <Text
            variant='h2'
            fontWeight={700}
            label={`${formatTicks(amount)} ${symbol}`}
          />
        </Box>
      }
    />
  )
}

export default memo(TransactionConfirmation)
